export const namespaced = true;

export const state = {
    countMounteds: 0,
    hash: null,
}

export const mutations = {
    INC_COUNT_MOUNTEDS(state) {
        state.countMounteds++;
    },
    SET_HASH(state, hash) {
        state.hash = hash;
    },

}

export const actions = {

    incCountMounteds({ commit }) {
        commit('INC_COUNT_MOUNTEDS');
    },

    setHash({ commit }, hash) {
        commit('SET_HASH', hash);
    },
}
